/** @format */

// import { filter } from "lodash";
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
  CardContent,
  Chip,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
import PhoneNumber from "../../dao/PhoneNumber";
import Waba from "../../dao/Waba";
import Select from "react-select";
import swal from "../../reusables/CustomSwal";

import { FaCheckDouble, FaRegCheckCircle } from "react-icons/fa";
import CardHeaderDashboard from "./CardHeader";

import qs from "qs";
import { useLocation } from "react-router";
import { Row, Col } from "react-bootstrap";

import moment from "moment";
import BroadcastDao from "src/dao/Broadcast";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "name", label: "Name", alignRight: false },
  { id: "phone_number", label: "Phone Number", alignRight: false },
  { id: "t", label: "Total Send", alignRight: false },
  { id: "delivered", label: "Delivered", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
];

// ----------------------------------------------------------------------
export default function Broadcast(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let id_waba = queryParams.waba_id;
  let id_phone_number = queryParams.phone_number;

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [headerData, setHeaderData] = useState({});
  const [headerData, setHeaderData] = useState({});
  const [isDataFetched, setIsDataFetched] = useState(true);
  const [data, setData] = useState([]);

  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState("");
  const [numberSelection, setNumberSelection] = useState([]);
  const [setCount] = useState(page * rowsPerPage + 1);

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log(result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      if (formatted.length > 0) {
        let wabaFromParam = formatted.find((obj) => obj.value === id_waba);

        if (wabaFromParam && id_waba) {
          setSelectedWabaId(wabaFromParam.value);
          setSelectedWabaLabel(wabaFromParam.label);
        } else {
          setSelectedWabaId(formatted[0].value);
          setSelectedWabaLabel(formatted[0].label);
        }
      }

      setWabaOptions(formatted);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchList = async () => {
    setIsDataFetched(true);
    try {
      let result = await BroadcastDao.getListBroadcast(
        selectedWabaId,
        selectedPhoneNumber?.value ? selectedPhoneNumber.value : ""
      );
      navigate(
        "?waba_id=" +
          selectedWabaId +
          "&phone_number=" +
          selectedPhoneNumber?.value ?? ""
      );

      let sortedData = await _.sortBy(result, "start", "ASC");
      const statusConvert = (param) => {
        return param.status;
      };

      let groupedData = await _.groupBy(sortedData, statusConvert);

      setHeaderData(groupedData);
      setData(result);
      setIsDataFetched(false);
    } catch (error) {
      console.error(error);
      setIsDataFetched(false);
    }
  };

  useEffect(() => {
    if (selectedWabaId && Object.keys(selectedPhoneNumber).length !== 0) {
      fetchList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId, selectedPhoneNumber]);

  useEffect(() => {
    getWabas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedWabaId) {
      getPhoneNumbers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId]);

  const getPhoneNumbers = async () => {
    try {
      let result = await PhoneNumber.getAll(selectedWabaId);

      let formatted = result.map((obj) => {
        return {
          label: `${obj.display_phone_number}`,
          value: obj.display_phone_number.replace(/[^\d]/g, ""),
        };
      });

      if (formatted.length > 0) {
        let phoneNumberParams = formatted.find(
          (obj) => obj.value === id_phone_number
        );

        if (phoneNumberParams && id_waba) {
          setSelectedPhoneNumber(phoneNumberParams);
        } else {
          setSelectedPhoneNumber(formatted[0]);
        }
      }
      setNumberSelection([
        {
          label: `All phone number`,
          value: "",
        },
        ...formatted,
      ]);
    } catch (e) {
      console.log("ERROR", e);
      await swal.fire({
        title: "Error",
        text: "An error has occurred. Please try again later.",
        icon: "error",
      });
    }
  };

  // let count =

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCount(page * rowsPerPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    data,
    getComparator(order, orderBy),
    filterName,
    "broadcast_name"
  );

  console.log(headerData);
  return (
    <Page title="Broadcast">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Broadcast
          </Typography>
        </Stack>

        <Row>
          <Col md={4}>
            <small>Filter by Waba ID :</small>
            <Select
              onChange={(option) => {
                // console.log(option);
                setSelectedWabaId(option.value);
                setSelectedWabaLabel(option.label);
              }}
              value={{
                label: selectedWabaLabel,
                value: selectedWabaId,
              }}
              options={wabaOptions}
            />
          </Col>
          <Col md={4}>
            <small>Select Phone Number :</small>
            <Select
              onChange={(option) => {
                setSelectedPhoneNumber(option);
              }}
              value={selectedPhoneNumber}
              options={numberSelection}
            />
          </Col>
        </Row>

        <Row
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Col md={6}>
            <CardHeaderDashboard
              label="Total Broadcast"
              icon={<FaCheckDouble fontSize={"1.5em"} />}
              value={data.length !== 0 ? data.length : 0}
            />
          </Col>
          <Col md={6}>
            <CardHeaderDashboard
              label=" Success Delivery"
              icon={<FaRegCheckCircle fontSize={"1.5em"} />}
              value={data.length !== 0 ? data.length : 0}
            />
          </Col>
        </Row>

        {wabaOptions.length > 0 && (
          <Card>
            <CardContent>
              <Row>
                <Col
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                  md={9}
                >
                  <SearchToolbar
                    filterName={filterName}
                    onFilterName={handleFilterByName}
                  />
                </Col>
                <Col
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                  md={3}
                >
                  <Button
                    onClick={() => {
                      navigate("/broadcast/create/" + selectedWabaId);
                    }}
                    fullWidth={true}
                    variant={"contained"}
                  >
                    + Create Broadcast
                  </Button>
                </Col>
              </Row>
            </CardContent>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table style={{ backgroundColor: "white", color: "white" }}>
                  <SortableTableHeader
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    onRequestSort={handleRequestSort}
                  />
                  {data.length !== 0 && !isDataFetched && (
                    <TableBody>
                      {filteredData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => {
                          const {
                            id,
                            broadcast_name,
                            phone_number,
                            total_rows,
                            created_at,
                            status,
                          } = row;
                          return (
                            <TableRow
                              hover
                              key={row.id}
                              tabIndex={-1}
                              role="checkbox"
                            >
                              <TableCell align="left">
                                {broadcast_name}
                              </TableCell>
                              <TableCell align="left">{phone_number}</TableCell>
                              <TableCell align="left">{total_rows}</TableCell>

                              <TableCell align="center">
                                {moment(created_at).format("DD MMM YYYY")}
                                <br />
                                <small>
                                  {moment(created_at).format("HH:mm")}
                                </small>
                              </TableCell>
                              <TableCell align="center">
                                <Chip
                                  label={status.toUpperCase()}
                                />
                              </TableCell>
                              <TableCell align="right">
                                <Button
                                  onClick={() => {
                                    navigate(`/broadcast/${id}`);
                                  }}
                                  variant={"outlined"}
                                  style={{ textDecoration: "none" }}
                                >
                                  Detail
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  )}
                  {data.length === 0 && !isDataFetched && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          {isDataFetched ? (
                            <CircularProgress />
                          ) : (
                            <SearchNotFound searchQuery={filterName} />
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                  {isDataFetched && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
      </Container>
    </Page>
  );
}
